export default __webpack_public_path__ + "static/media/Lino_Silva_-_Resume.15228c81.pdf";